import { FC } from 'react';

type Props = {
  size?: number,
  className?: string,
};

// Outline sibling of warningIcon.jsx (the Material filled glyph): stroke-based
// warning triangle that inherits the parent's text colour via currentColor.
// Extracted from the Next-sync conflict UI, where it was defined in three
// files (NextConflictSection, ExportNextProjectModal, UpdateFromNextModal).
const WarningOutlineIcon: FC<Props> = ({ size = 16, className }) => (
  <svg className={className} width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round">
    <path d="M12 3l9 16H3z"></path>
    <path d="M12 10v4"></path>
    <path d="M12 17.5v.5"></path>
  </svg>
);

export default WarningOutlineIcon;
